import { Component, OnInit, ViewEncapsulation, EventEmitter, ViewChild, Input, Output, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DataManager, WebApiAdaptor, Query, DataOptions, ReturnOption, UrlAdaptor } from '@syncfusion/ej2-data';
import { DropDownList } from '@syncfusion/ej2-dropdowns';
import { createElement, extend, Ajax, L10n, loadCldr } from '@syncfusion/ej2-base';
import * as momenttz from 'moment-timezone';
import { Timezone } from '@syncfusion/ej2-schedule';
import { Environment } from '../app.environment';

import { MyModal } from '../components/modal/modal';
import { Api, Session } from '../services/index';
import { ProviderBio } from '../models/provider';
import { EJ2Instance, Schedule, RecurrenceEditor, PopupOpenEventArgs, EventRenderedArgs, RenderCellEventArgs } from '@syncfusion/ej2-angular-schedule';
import { EventSettingsModel, ScheduleComponent, View } from '@syncfusion/ej2-angular-schedule';

import * as numberingSystems from './numberingSystems.json';
import * as gregorian from './ca-gregorian.json';
import * as numbers from './numbers.json';
import * as timeZoneNames from './timeZoneNames.json';
import * as currencies from './currencies.json';



import { NotificationsService } from 'angular2-notifications';
import { SavePatientSchedule, ProviderScheduleForPatient, ProviderBioFullDetail, Patient} from '../models';


import { isNullOrUndefined } from 'util';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-disclosure-statement',
  templateUrl: './disclosure-statement.component.html',
  styleUrls: ['./disclosure-statement.component.css']
})
export class DisclosureStatementComponent implements OnInit {

  scheduledProviderBio: ProviderBio;
  isAgree: boolean = false;
  providerId: number;
  providerBio: ProviderBioFullDetail;
  intakeScheduleDate: Date;
  currentDate: Date;
  patient: Patient;
  patientName: String;
  constructor(private env: Environment,
    public session: Session,
    public api: Api,
    public notification: NotificationsService,
    private route: ActivatedRoute,
    private router: Router) {

      this.currentDate = new Date();
      
      this.scheduledProviderBio = new ProviderBio();
      this.providerBio = new ProviderBioFullDetail();
      this.providerId = this.session.intakeSchedule.providerId;
      let _getFullProviderBio = this.api.getFullProviderBio(this.providerId).map(res => {
        this.providerBio = res;
      });

      let _getPatientById = this.api.getPatientById(this.session.patientId).map(patientres => {
        this.patient = patientres;
        
      });

      Observable.forkJoin([_getFullProviderBio,
        _getPatientById]).subscribe(obsRes => {
          this.patientName = this.patient.profile.firstName + ' ' + this.patient.profile.lastName;
        });
     }

  ngOnInit() {
  }

  continue(){
    if (this.session.intakeLob === 'BH') {
      this.router.navigate(['/exam-have-allergies/' + this.session.patient.userId]);
    } else {
      this.router.navigate(['/exam-select-pharmacy/' + this.session.patient.userId]);
    }
  }
  
  opendisclosure() {
    let caredocurl = "http://memd.force.com/agreement/agreements?name=bhdisclosure";
    let newWindow = window.open("about:blank", "_blank");
    newWindow.opener = null;
    newWindow.location.href = caredocurl;
  }
  toggleAgree(){

  }
}
